const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // Um subscriber que quebra nao pode derrubar quem publicou. Era o que
      // acontecia no adicionar ao carrinho: o onCartUpdate estourava aqui, a
      // excecao subia ate o .then() do product-form e o renderContents (drawer
      // + bubble) nunca rodava. O item entrava no carrinho e a tela nao reagia.
      try {
        callback(data);
      } catch (e) {
        console.error(`[pubsub] subscriber de "${eventName}" falhou:`, e);
      }
    });
  }
}
